import React, {Component} from 'react';
import {connect} from 'react-redux';
import { SearchFilterBar, Page } from 'signoxe/components';
import { Button } from 'signoxe/components/widgets'
import { Box } from 'signoxe/components/layout';
import { Icon } from 'signoxe/components/widgets';
import { delete_pairing_code } from 'signoxe/actions/deviceActions';

class PairDevice extends Component {
    constructor(props) {
        super(props);
        this.state = {
            index: 0, 
        }
    }
    
    handleDelete = (id) => {
        this.props.delete_pairing_code(id)
    }

    licenseChange = data => {
        this.setState({index: data})
    }

    licenses = () => {
        let options = []
        this.props.licenses && this.props.licenses.map((data, index) => {
            options.push(
                <option key={index} value={index}>
                    {data.mode}
                </option>
            )
        })

        return options
    }

    
    render()
    {
    
        return (
            <Page>
                <Box>
                    <table className="device-list">
                        <thead>
                            <tr>
                                <th>Pairing Codes</th>
                                <th>Device Name</th>
                                <th>Type of License</th>
                                <th>Activation Date</th>
                                <th>Expiry Date Date</th>
                                <th></th>
                            </tr>
                        </thead>
                        <tbody className={'device-table'}>
                        {this.props.devices.length > 0 && this.props.devices.map((data, index) => (
                            <tr key={index}>
                                <td>{data.code}</td>
                                <td>{data.device}</td>
                                <td>{data.license}</td>
                                <td>{data.activation_date}</td>
                                <td>{data.expiry_date}</td>
                            {!data.device && <td><i onClick={() => this.handleDelete(data.id)} className="fa-solid fa-trash-can"></i></td>}
                        </tr>
                        ))}
                        </tbody>
                    </table>
                </Box>
                
                <Box>
                    <table className="device-list" style={{marginTop: '20px'}}>
                        <tbody>
                            <tr style={{display: 'flex', alignItems: 'center'}}>
                                <td>
                                    <select id="licenses" onChange={(event) => this.licenseChange(event.target.options.selectedIndex)}>
                                        {this.licenses()}
                                    </select>
                                </td>

                                <td>
                                    No of Licenses Purchased: {this.props.licenses[this.state.index] && this.props.licenses[this.state.index].total}
                                </td>
                                <td>
                                    Total Consumed: {this.props.licenses[this.state.index] && this.props.licenses[this.state.index].used}
                                </td>
                                <td>
                                    No of Licenses Remaining: {this.props.licenses[this.state.index] && this.props.licenses[this.state.index].license_number}
                                </td>
        
                            </tr>
                        </tbody>
                    </table>
                </Box>
                
                
            </Page>
        )
    }
    
}

const mapStateToProps = state => ({
    devices: state.deviceState.deviceReducer.paring_codes,
    licenses: state.deviceState.deviceReducer.licenses
})

export default connect(mapStateToProps,{delete_pairing_code})(PairDevice);


// WEBPACK FOOTER //
// ./node_modules/source-map-loader!./src/containers/DevicesPage/tabs/PairDevice/index.js